"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ApplicationClient_1 = __importDefault(require("./ApplicationClient"));
const ChargebeeClient_1 = __importDefault(require("./ChargebeeClient"));
const DeviceClient_1 = __importDefault(require("./DeviceClient"));
const errors_1 = require("./errors");
const FileUploadClient_1 = __importDefault(require("./FileUploadClient"));
const PlaylistClient_1 = __importDefault(require("./PlaylistClient"));
const PresentationClient_1 = __importDefault(require("./PresentationClient"));
const ThemeClient_1 = __importDefault(require("./ThemeClient"));
const UserClient_1 = __importDefault(require("./UserClient"));
const FolderClient_1 = __importDefault(require("./FolderClient"));
const DomainClient_1 = __importDefault(require("./DomainClient"));
const ResourceClient_1 = __importDefault(require("./ResourceClient"));
const PlaybackReportClient_1 = __importDefault(require("./PlaybackReportClient"));
const FontClient_1 = __importDefault(require("./FontClient"));
const AccountClient_1 = __importDefault(require("./AccountClient"));
const PaymentClient_1 = __importDefault(require("./PaymentClient"));
const InvoiceClient_1 = __importDefault(require("./InvoiceClient"));
const AdminClient_1 = __importDefault(require("./AdminClient"));
const AnalyticsClient_1 = __importDefault(require("./AnalyticsClient"));
const CatalogClient_1 = __importDefault(require("./CatalogClient"));
const ConnectionClient_1 = __importDefault(require("./ConnectionClient"));
const LocationClient_1 = __importDefault(require("./LocationClient"));
const ConnectorClient_1 = __importDefault(require("./ConnectorClient"));
const LibraryClient_1 = __importDefault(require("./LibraryClient"));
const getApiClientError = (response) => __awaiter(void 0, void 0, void 0, function* () {
    const text = (yield response.text()) || response.statusText;
    switch (response.status) {
        case 400:
            return new errors_1.BadRequestError(text);
        case 401:
            return new errors_1.UnauthorizedError(text);
        case 403:
            return new errors_1.ForbiddenError(text);
        case 404:
            return new errors_1.NotFoundError(text);
        case 500:
            return new errors_1.InternalServerError(text);
        default:
            return new errors_1.BadRequestError(text);
    }
});
class ApiClient {
    constructor(opts) {
        var _a;
        // Folders
        this.getDevicesFolder = FolderClient_1.default.prototype.getDevicesFolder;
        this.getV5DevicesFolder = FolderClient_1.default.prototype.getV5DevicesFolder;
        this.getLibraryFolder = FolderClient_1.default.prototype.getLibraryFolder;
        this.getFolder = FolderClient_1.default.prototype.getFolder;
        this.createFolder = FolderClient_1.default.prototype.createFolder;
        this.updateFolder = FolderClient_1.default.prototype.updateFolder;
        this.deleteFolder = FolderClient_1.default.prototype.deleteFolder;
        this.moveFolderToFolder = FolderClient_1.default.prototype.moveFolderToFolder;
        this.getV4DevicesFolder = FolderClient_1.default.prototype.getV4DevicesFolder;
        this.getV4LibraryFolder = FolderClient_1.default.prototype.getV4LibraryFolder;
        this.getV4LibraryLiteFolder = FolderClient_1.default.prototype.getV4LibraryLiteFolder;
        // Devices
        this.getDevices = DeviceClient_1.default.prototype.getDevices;
        this.getV4ReportingDevices = DeviceClient_1.default.prototype.getV4ReportingDevices;
        this.getV5Devices = DeviceClient_1.default.prototype.getV5Devices;
        this.getDevice = DeviceClient_1.default.prototype.getDevice;
        this.publishDevice = DeviceClient_1.default.prototype.publishDevice;
        this.registerDevice = DeviceClient_1.default.prototype.registerDevice;
        this.updateDevice = DeviceClient_1.default.prototype.updateDevice;
        this.updateV5Device = DeviceClient_1.default.prototype.updateV5Device;
        this.restartDevice = DeviceClient_1.default.prototype.restartDevice;
        this.rebootDevice = DeviceClient_1.default.prototype.rebootDevice;
        this.getSYBSoundZone = DeviceClient_1.default.prototype.getSYBSoundZone;
        this.generateSYBPairingCode = DeviceClient_1.default.prototype.generateSYBPairingCode;
        this.moveDeviceToFolder = DeviceClient_1.default.prototype.moveDeviceToFolder;
        this.getAffectedDevices = DeviceClient_1.default.prototype.getAffectedDevices;
        this.unregisterDevice = DeviceClient_1.default.prototype.unregisterDevice;
        this.getRecentDeviceErrors = DeviceClient_1.default.prototype.getRecentDeviceErrors;
        this.batchDeviceSettings = DeviceClient_1.default.prototype.batchDeviceSettings;
        this.getBatchDeviceStatus = DeviceClient_1.default.prototype.getBatchDeviceStatus;
        // Device
        this.getV5Device = DeviceClient_1.default.prototype.getV5Device;
        this.deviceHeartbeat = DeviceClient_1.default.prototype.deviceHeartbeat;
        this.getDevicePublishedContent = DeviceClient_1.default.prototype.getDevicePublishedContent;
        this.getDeviceAdContent = DeviceClient_1.default.prototype.getDeviceAdContent;
        this.devicePubnubAuth = DeviceClient_1.default.prototype.devicePubnubAuth;
        this.enableMultiTimezone = DeviceClient_1.default.prototype.enableMultiTimezone;
        this.createDeviceCharge = DeviceClient_1.default.prototype.createDeviceCharge;
        this.updateDeviceCharge = DeviceClient_1.default.prototype.updateDeviceCharge;
        // Device Services
        this.enableDeviceService = DeviceClient_1.default.prototype.enableDeviceService;
        this.disableDeviceService = DeviceClient_1.default.prototype.disableDeviceService;
        // Device AI
        this.getDeviceAISettings = DeviceClient_1.default.prototype.getDeviceAISettings;
        this.setDeviceAISettings = DeviceClient_1.default.prototype.setDeviceAISettings;
        this.setDeviceAILicenseKey = DeviceClient_1.default.prototype.setDeviceAILicenseKey;
        this.startDeviceAIVideo = DeviceClient_1.default.prototype.startDeviceAIVideo;
        this.stopDeviceAIVideo = DeviceClient_1.default.prototype.stopDeviceAIVideo;
        // Device Perchview
        this.getDevicePerchviewSettings = DeviceClient_1.default.prototype.getDevicePerchviewSettings;
        this.getOwnPerchviewSettings = DeviceClient_1.default.prototype.getOwnPerchviewSettings;
        this.setDevicePerchviewSettings = DeviceClient_1.default.prototype.setDevicePerchviewSettings;
        this.updateDevicePerchviewSettings = DeviceClient_1.default.prototype.updateDevicePerchviewSettings;
        // Device V2 Perchview
        this.getDeviceV2PerchviewSettings = DeviceClient_1.default.prototype.getDeviceV2PerchviewSettings;
        this.setDeviceV2PerchviewSettings = DeviceClient_1.default.prototype.setDeviceV2PerchviewSettings;
        this.updateDeviceV2PerchviewSettings = DeviceClient_1.default.prototype.updateDeviceV2PerchviewSettings;
        // Device Payment Terminal
        this.getDeviceTerminalStatus = DeviceClient_1.default.prototype.getDeviceTerminalStatus;
        this.getDeviceTerminal = DeviceClient_1.default.prototype.getDeviceTerminal;
        this.deleteDeviceTerminal = DeviceClient_1.default.prototype.deleteDeviceTerminal;
        // Users
        this.getProfile = UserClient_1.default.prototype.getProfile;
        this.updateProfile = UserClient_1.default.prototype.updateProfile;
        this.masquerade = UserClient_1.default.prototype.masquerade;
        this.unsubscribe = UserClient_1.default.prototype.unsubscribe;
        this.getUserStatus = UserClient_1.default.prototype.getUserStatus;
        this.setRemoteAssistance = UserClient_1.default.prototype.setRemoteAssistance;
        this.remoteAssist = UserClient_1.default.prototype.remoteAssist;
        this.changeEmail = UserClient_1.default.prototype.changeEmail;
        this.getOnboardingStatus = UserClient_1.default.prototype.getOnboardingStatus;
        this.updateOnboardingStatus = UserClient_1.default.prototype.updateOnboardingStatus;
        // Presentations
        this.getPresentations = PresentationClient_1.default.prototype.getPresentations;
        this.deletePresentation = PresentationClient_1.default.prototype.deletePresentation;
        this.updatePresentation = PresentationClient_1.default.prototype.updatePresentation;
        this.createPresentation = PresentationClient_1.default.prototype.createPresentation;
        this.movePresentationToFolder = PresentationClient_1.default.prototype.movePresentationToFolder;
        this.copyPresentation = PresentationClient_1.default.prototype.copyPresentation;
        this.getPresentationsList = PresentationClient_1.default.prototype.getPresentationsList;
        // Playlists
        this.getPlaylists = PlaylistClient_1.default.prototype.getPlaylists;
        this.createPlaylist = PlaylistClient_1.default.prototype.createPlaylist;
        this.updatePlaylist = PlaylistClient_1.default.prototype.updatePlaylist;
        this.deletePlaylist = PlaylistClient_1.default.prototype.deletePlaylist;
        this.movePlaylistToFolder = PlaylistClient_1.default.prototype.movePlaylistToFolder;
        this.getPlaylistPlaybackContent = PlaylistClient_1.default.prototype.getPlaylistPlaybackContent;
        this.copyPlaylist = PlaylistClient_1.default.prototype.copyPlaylist;
        // File uploads
        this.uploadFile = FileUploadClient_1.default.prototype.uploadFile;
        // Fonts
        this.getFonts = FontClient_1.default.prototype.getFonts;
        this.createFont = FontClient_1.default.prototype.createFont;
        // Applications
        this.getApplications = ApplicationClient_1.default.prototype.getApplications;
        this.createApplication = ApplicationClient_1.default.prototype.createApplication;
        this.createApplicationVersion = ApplicationClient_1.default.prototype.createApplicationVersion;
        this.updateApplication = ApplicationClient_1.default.prototype.updateApplication;
        this.getApplicationVersions = ApplicationClient_1.default.prototype.getApplicationVersions;
        this.getMarketPlaceApplications = ApplicationClient_1.default.prototype.getMarketPlaceApplications;
        this.sendMarketPlaceInquiry = ApplicationClient_1.default.prototype.sendMarketPlaceInquiry;
        this.getProductList = ApplicationClient_1.default.prototype.getProductList;
        this.getEXLicenses = ApplicationClient_1.default.prototype.getEXLicenses;
        this.purchaseProduct = ApplicationClient_1.default.prototype.purchaseProduct;
        this.generateApplicationVersionToken = ApplicationClient_1.default.prototype.generateApplicationVersionToken;
        // Themes
        this.getThemes = ThemeClient_1.default.prototype.getThemes;
        this.updateTheme = ThemeClient_1.default.prototype.updateTheme;
        this.createTheme = ThemeClient_1.default.prototype.createTheme;
        this.deleteTheme = ThemeClient_1.default.prototype.deleteTheme;
        // Domain
        this.getDomain = DomainClient_1.default.prototype.getDomain;
        this.updateDomain = DomainClient_1.default.prototype.updateDomain;
        this.inviteToDomain = DomainClient_1.default.prototype.inviteToDomain;
        this.setProfileDomainRole = DomainClient_1.default.prototype.setProfileDomainRole;
        // Enterprise Invite
        this.getDomainUsers = DomainClient_1.default.prototype.getDomainUsers;
        this.getPendingDomainUsers = DomainClient_1.default.prototype.getPendingDomainUsers;
        this.validateEmail = DomainClient_1.default.prototype.validateEmail;
        this.inviteDomainUser = DomainClient_1.default.prototype.inviteDomainUser;
        this.resendDomainInvite = DomainClient_1.default.prototype.resendDomainInvite;
        this.cancelDomainInvite = DomainClient_1.default.prototype.cancelDomainInvite;
        this.acceptDomainInvite = DomainClient_1.default.prototype.acceptDomainInvite;
        this.updateDomainUser = DomainClient_1.default.prototype.updateDomainUser;
        this.updateDomainInvite = DomainClient_1.default.prototype.updateDomainInvite;
        // Resources
        this.createResourceACL = ResourceClient_1.default.prototype.createResourceACL;
        this.deleteResourceACL = ResourceClient_1.default.prototype.deleteResourceACL;
        this.listResourceACLs = ResourceClient_1.default.prototype.listResourceACLs;
        this.createResourceACLV5 = ResourceClient_1.default.prototype.createResourceACLV5;
        this.updateResourceACLV5 = ResourceClient_1.default.prototype.updateResourceACLV5;
        this.deleteResourceACLV5 = ResourceClient_1.default.prototype.deleteResourceACLV5;
        // Playback Report
        this.getPlaybackReports = PlaybackReportClient_1.default.prototype.getPlaybackReports;
        this.generatePlaybackReport = PlaybackReportClient_1.default.prototype.generatePlaybackReport;
        // Chargebee
        this.generateChargebeePortal = ChargebeeClient_1.default.prototype.generateChargebeePortal;
        // Invoices
        this.chargeInvoice = InvoiceClient_1.default.prototype.chargeInvoice;
        this.getInvoices = InvoiceClient_1.default.prototype.getInvoices;
        this.downloadInvoices = InvoiceClient_1.default.prototype.downloadInvoice;
        this.toggleInvoiceEmail = InvoiceClient_1.default.prototype.toggleInvoiceEmail;
        this.getOutstandingBalance = InvoiceClient_1.default.prototype.getOutstandingBalance;
        // Account
        this.getAddress = AccountClient_1.default.prototype.getAddress;
        this.getCountries = AccountClient_1.default.prototype.getCountries;
        this.updateAddress = AccountClient_1.default.prototype.updateAddress;
        //Payments
        this.captureContext = PaymentClient_1.default.prototype.captureContext;
        this.getPaymentMethods = PaymentClient_1.default.prototype.getPaymentMethods;
        this.addPaymentMethod = PaymentClient_1.default.prototype.addPaymentMethod;
        // Support app
        this.getProfileDevices = AdminClient_1.default.prototype.getProfileDevices;
        this.getProfilesByRecentDevices = AdminClient_1.default.prototype.getProfilesByRecentDevices;
        this.disableDevice = AdminClient_1.default.prototype.disableDevice;
        this.enableDevice = AdminClient_1.default.prototype.enableDevice;
        this.getDeviceByMacAddress = AdminClient_1.default.prototype.getDeviceByMacAddress;
        this.updateAdminDevice = AdminClient_1.default.prototype.updateAdminDevice;
        // Analytics
        this.getAnalytics = AnalyticsClient_1.default.prototype.getAnalytics;
        this.getContentEngagement = AnalyticsClient_1.default.prototype.getContentEngagement;
        this.getTrafficAwareness = AnalyticsClient_1.default.prototype.getTrafficAwareness;
        this.getProductEngagementExport = AnalyticsClient_1.default.prototype.getProductEngagementExport;
        this.getContentEngagementClickExport = AnalyticsClient_1.default.prototype.getContentEngagementClickExport;
        this.getTrafficAwarenessExport = AnalyticsClient_1.default.prototype.getTrafficAwarenessExport;
        this.getContentEngagementExport = AnalyticsClient_1.default.prototype.getContentEngagementExport;
        this.getAnalyticsLocations = AnalyticsClient_1.default.prototype.getLocations;
        this.getContentDetail = AnalyticsClient_1.default.prototype.getContentDetail;
        // Catalogs
        this.getCatalogs = CatalogClient_1.default.prototype.getCatalogs;
        this.createCatalog = CatalogClient_1.default.prototype.createCatalog;
        this.updateCatalog = CatalogClient_1.default.prototype.updateCatalog;
        this.deleteCatalog = CatalogClient_1.default.prototype.deleteCatalog;
        // Products
        this.getProducts = CatalogClient_1.default.prototype.getProducts;
        // Catalog locations
        this.getCatalogLocations = CatalogClient_1.default.prototype.getCatalogLocations;
        // Connections
        this.getConnections = ConnectionClient_1.default.prototype.getConnections;
        this.createConnection = ConnectionClient_1.default.prototype.createConnection;
        this.updateConnection = ConnectionClient_1.default.prototype.updateConnection;
        this.deleteConnection = ConnectionClient_1.default.prototype.deleteConnection;
        // Connectors
        this.getConnectors = ConnectorClient_1.default.prototype.getConnectors;
        // Locations
        this.getLocations = LocationClient_1.default.prototype.getLocations;
        this.createLocation = LocationClient_1.default.prototype.createLocation;
        this.editLocation = LocationClient_1.default.prototype.editLocation;
        this.deleleteLocation = LocationClient_1.default.prototype.deleteLocation;
        this.getPendingLocations = LocationClient_1.default.prototype.getPendingLocations;
        this.inviteUserToLocation = LocationClient_1.default.prototype.inviteUserToLocation;
        this.removeUserFromLocation = LocationClient_1.default.prototype.removeUserFromLocation;
        this.moveDevicesToAnotherLocation = LocationClient_1.default.prototype.moveDevicesToAnotherLocation;
        // Libraries
        this.getLibrary = LibraryClient_1.default.prototype.getLibrary;
        this.baseUrl = opts.baseUrl;
        this.accessToken = opts.accessToken;
        this.getAccessToken = opts.getAccessToken;
        this.isBearerToken = (_a = opts.isBearerToken) !== null && _a !== void 0 ? _a : false;
        this.fetcher = opts.fetcher;
    }
    setAccessToken(accessToken) {
        this.accessToken = accessToken;
    }
    requestProtected(opts) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            let accessToken = this.accessToken;
            if (this.getAccessToken) {
                accessToken = yield this.getAccessToken(opts);
            }
            if (!accessToken)
                throw new errors_1.UnauthorizedError('Missing access token');
            const response = yield this.fetcher(`${this.baseUrl}${opts.url}`, Object.assign({ method: opts.method, headers: Object.assign({ 'Content-Type': 'application/json' }, (this.isBearerToken
                    ? { Authorization: `Bearer ${accessToken}` }
                    : { 'Mira-ApiKey': accessToken })) }, (opts.body ? { body: JSON.stringify(opts.body) } : {})));
            if (!response.ok)
                throw yield getApiClientError(response);
            if ((_a = response.headers.get('Content-Type')) === null || _a === void 0 ? void 0 : _a.includes('application/json')) {
                return yield response.json();
            }
            if ((_b = response.headers.get('Content-Type')) === null || _b === void 0 ? void 0 : _b.includes('application/zip')) {
                return (yield response.blob());
            }
            return (yield response.text());
        });
    }
    requestPublic(opts) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.fetcher(`${this.baseUrl}${opts.url}`, Object.assign({ method: opts.method, headers: {
                    'Content-Type': 'application/json',
                } }, (opts.body ? { body: JSON.stringify(opts.body) } : {})));
            if (!response.ok)
                throw yield getApiClientError(response);
            if ((_a = response.headers.get('Content-Type')) === null || _a === void 0 ? void 0 : _a.includes('application/json')) {
                return yield response.json();
            }
            return (yield response.text());
        });
    }
}
exports.default = ApiClient;
